import { Descriptions } from 'antd';

import { GetShiftReportPdfMetadataQuery } from 'generated/graphql';

import { useBuildMetadataDescriptionItems } from './use-build-metadata-description-items';

interface ReportMetadataTableProps {
  report: NonNullable<GetShiftReportPdfMetadataQuery['shiftReport']>;
}

export const ReportMetadataTable = ({ report }: ReportMetadataTableProps) => {
  const items = useBuildMetadataDescriptionItems({
    report,
  });

  return (
    <Descriptions
      items={items}
      column={{ xs: 1, sm: 6, md: 6, lg: 6, xl: 6, xxl: 6 }}
      className="header-info"
      bordered={false}
    />
  );
};
